module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAU5JREFUOE/NkztLA0EUhc+Z0YCk0FYUhDRiq7ha5jdomW1EfASDYGWhoIKCVopE1IDaJKX/IaUPtNROEBRLCxVhk5kru5sNWUlCykwzzNx7v5lzZi7RYngZZ5lAzg8LkE+U7s6apfL/pqTTPWb450SEC0psELdUIKWg35IrLJerjTUxgOdOj1PklLCjSmw//bODGxCW+lvAJyGzieLNYwSpAzx3ao4ieQXrKbEDza5rqL8E1ELmEsXbKz8nAFQyk4cgs8raqoJNtvKlJufXQvUBctRbul9jxXX2IZjRYlKE6HbFUUxAY6g/AVyyknFEi0GktxNA5IuhRjcD5jeAwZFQ0ccrcLEXU+c/bWsJqwdh8vtLOA+lwvl4vQ5pD9gsAM8PwPV5WDC7BIxNALuL3QxodChoHr8DpNYLDFZQYmNGhia6zjYEW51+oFgesfMHtC61FnChgkMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xtsy-1.png
// module id = 8NN5
// module chunks = 7